// Order Item type definitions

export type OrderItemCreateInput = {
  asset_template_id: string;
  asset_instance_id?: string | null;
  quantity: number;
  rental_length_months: number;
  unit_price: number;
  notes?: string | null;
};

export type OrderItemUpdateInput = Partial<OrderItemCreateInput>;

export type OrderItem = {
  id: string;
  order_id: string;
  asset_template_id: string;
  asset_instance_id?: string | null;
  quantity: number;
  rental_length_months: number;
  unit_price: number;
  total_price: number;
  notes?: string | null;
  created_at: string;
  updated_at: string;
  // Associations
  asset_template?: {
    id: string;
    name: string;
    description?: string;
    base_price?: number;
    image_url?: string;
  };
  asset_instance?: {
    id: string;
    instance_number: string;
    serial_number?: string;
  };
};

export const RENTAL_LENGTH_OPTIONS = [
  { value: 1, label: '1 month', priceMultiplier: 1.0 },
  { value: 2, label: '2 months', priceMultiplier: 0.95 },
  { value: 3, label: '3 months', priceMultiplier: 0.90 },
  { value: 6, label: '6 months', priceMultiplier: 0.85 },
  { value: 12, label: '12 months', priceMultiplier: 0.80 },
  { value: 24, label: '24 months', priceMultiplier: 0.75 },
];

